import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, TextInput } from '@mantine/core'
import { validation } from '../../../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { editProduct } from '../../../../../services/products'

const defaultVal = {
  video_url: '',
}

const formValidation = {
  video_url: {
    isError: false,
    message: ''
  },
}

const FormAdjustVideoProduct = ({ idProduct, detail, onCloseForm, reloadDetail }) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)

  const validateYouTubeUrl = (urlToParse) => {
    if (urlToParse) {
      var regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      if (urlToParse.match(regExp)) {
        return true
      }
    }
    return false
  }

  const submitVideoUrlProduct = async (form) => {
    setLoadingSubmit(true)
    setValidationForm(formValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''
    const isError = validation(form, setValidationForm)
    if (isError) {
      setLoadingSubmit(false)
      return
    }
    if (!validateYouTubeUrl(form.video_url)) {
      setValidationForm((oldVal) => ({
        ...oldVal,
        video_url: {
          isError: true,
          message: 'Invalid YouTube URL format'
        }
      }))
      setLoadingSubmit(false)
      return
    }
    if (detail !== null) {
      const payload = {
        videos: {
          id: detail.id,
          source: form.video_url
        }
      }
      methodFunction = editProduct(idProduct, payload)
      titleMessageSuccess = 'Update Video URL Product Successfully'
      captionMessageSuccess = 'You have been updated video URL product'
      titleMessageError = 'Update Video URL Product Failed'
    } else {
      const payload = {
        videos: {
          source: [form.video_url]
        }
      }
      methodFunction = editProduct(idProduct, payload)
      titleMessageSuccess = 'Add Video URL Product Successfully'
      captionMessageSuccess = 'You have been added new video URL product'
      titleMessageError = 'Add Video URL Product Failed'
    }
    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        onCloseForm()
        reloadDetail()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'There is an error while adding video URL product'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingSubmit(false)
    }
  }

  useEffect(() => {
    if (detail !== null) {
      setFormData({
        video_url: detail.source || '',
      })
    }
  }, [detail])

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box>
        <TextInput
          name='video_url'
          value={formData.video_url}
          label='Video URL (Youtube Only)'
          description='Example Youtube URL: https://www.youtube.com/watch?v=example'
          placeholder='https://www.youtube.com/watch?v=example'
          error={validationForm.video_url.isError ? `${validationForm.video_url.message}` : ''}
          onChange={(val) => handleChangeForm('video_url', val.target.value)}
          withAsterisk
          size='xs'
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' variant="filled" loading={loadingSubmit} onClick={() => submitVideoUrlProduct(formData)}>{detail !== null ? 'Update' : 'Add'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustVideoProduct